// Pure helpers extracted from VoucherPreview for unit-testing.
// These mirror the component's live computation exactly — no behaviour change.

// Sum Dr and Cr amounts, take the absolute difference, and flag balance within
// a 0.01 (one-paisa) tolerance.
export function computeBalance(entries) {
  const totalDr = entries
    .filter(e => e.dr_cr === 'Dr')
    .reduce((sum, e) => sum + (Number(e.amount) || 0), 0);
  const totalCr = entries
    .filter(e => e.dr_cr === 'Cr')
    .reduce((sum, e) => sum + (Number(e.amount) || 0), 0);
  const balanceDiff = Math.abs(totalDr - totalCr);
  const isBalanced = balanceDiff < 0.01;
  return { totalDr, totalCr, balanceDiff, isBalanced };
}

// True when any entry's Dr/Cr, amount, or ledger_name differs from its
// original value and the push has not already succeeded.
export function computeUnsavedEdits(editedEntries, originalEntries, pushSuccess) {
  if (pushSuccess) return false;
  // Count change (add/delete row) is always an unsaved edit
  if (editedEntries.length !== originalEntries.length) return true;
  return editedEntries.some((entry, idx) => {
    const original = originalEntries[idx];
    if (!original) return false;
    return entry.dr_cr !== original.dr_cr ||
      (Number(entry.amount) || 0) !== (Number(original.amount) || 0) ||
      entry.ledger_name !== original.ledger_name;
  });
}

// True when any tracked header field differs from its original value
// and the push has not already succeeded.
export function computeUnsavedHeaderEdits(editedInfo, originalInfo, pushSuccess) {
  if (pushSuccess) return false;
  if (!editedInfo || !originalInfo) return false;
  return ['party_name', 'voucher_number', 'date', 'narration'].some(
    key => (editedInfo[key] || '') !== (originalInfo[key] || '')
  );
}
